<template>
  <div class="row no-wrap">
    <div
      class="column col-auto justify-start"
    >
      <div
        class="row items-center justify-end"
        style="min-width: 26px; min-height: 20px;"
      >
        <q-space />
        <q-badge
          :style="badgeStyles"
          :label="count"
          color="primary"
          :text-color="$isColorDark(currentSite.primaryColor) ? 'white' : 'dark'"
          rounded
        />
      </div>
    </div>
    <div>
      <div
        :class="textClasses"
        :style="textStyles"
      >
        <div
          class="text-uppercase"
          :style="itemStyles"
        >
          <span>{{ itemName }}</span>
          <span v-if="!!itemVariationName">
            |
          </span>
          <span
            v-if="!!itemVariationName"
            class="text-italic"
          >
            {{ itemVariationName }}
          </span>
        </div>
        <div
          v-if="modifiers.length > 0"
          class="q-pl-sm"
          style="min-height: 2px;"
        >
          <div
            v-for="modifier in modifiers"
            :key="`${itemName}_${itemVariationName}_${modifier}`"
          >
            {{ modifier }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KitchenSummaryItem',
  configuration: ['currentSite'],
  props: {
    itemName: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    itemVariationName: {
      type: String,
      required: false,
      default: null
    },
    modifiers: {
      type: Array,
      required: false,
      default: () => ([])
    },
    size: {
      type: String,
      required: false,
      default: 'sm'
    }
  },
  computed: {
    badgeStyles () {
      if (this.size === 'lg') {
        return 'border-radius: 1.125rem; line-height: 1.125rem; font-size: 1rem; font-weight: bold; margin-top: 2px; margin-right: 4px;'
      }

      return 'margin-right: 2px;'
    },
    textClasses () {
      if (this.size === 'lg') {
        return 'text-subtitle1'
      }

      return ''
    },
    textStyles () {
      if (this.size === 'lg') {
        return ''
      }

      return 'margin-bottom: 6px;'
    },
    itemStyles () {
      if (this.size === 'lg') {
        return 'font-size: 1rem; font-weight: bold;'
      }

      return ''
    }
  }
}
</script>
